






























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { riskTypeFind } from '@/api/portfolio'
import { custormSave } from '@/api/users'
import { CommonMudule } from '@/store/modules/common'
import DialogSlot from '@/components/dialog/doalogSlot.vue'
import FormItem from '@/components/formItem/index.vue'
import TsForm from '@/components/TsForm/index.vue'
@Component({
  components: {
    DialogSlot,
    TsForm,
    FormItem,
  },
})
export default class extends Vue {
  @Prop() type!: string // 类型 判断点击按钮触发￥emit 还是打开弹框
  @Prop() propData!: {}
  dialogShow = false;
  form = {
    // customerName: '',
    // gender: 0,
    // age: ''
  };

  data: { title: string; name: string }[] = [];

   sexItem = [{
     label: '男',
     value: '0'
   }, {
     label: '女',
     value: '1'
   }]

   created () {
     this.getBaseInfo()
   }

   private async getBaseInfo () {
     const res = await riskTypeFind({
       customerId: CommonMudule.customerId,
     })
     const data = res.data
     this.form = {
       ...data,
       gender: data.gender + ''
     }
     this.data = [
       {
         title: '称呼',
         name: data.customerName,
       },
       {
         title: '性别',
         name: data.gender === 0 ? '男' : '女',
       },
       {
         title: '年龄',
         name: data.age,
       },
     ]
   }

   //  private handleShowDialog () {
   //    if (this.type) {
   //      this.$emit('on-base-info-btn', this.type)
   //      return
   //    }
   //    this.dialogShow = true
   //  }

   private handleClose () {
     this.dialogShow = false
   }

   private async handleConfirm () {
     const value = this.$validator(this.$refs.form)
     if (!value) {
       const res = await custormSave(this.form)
       if (res?.data) {
         this.$message({
           type: 'success',
           message: '修改成功'
         })
         this.dialogShow = false
         this.getBaseInfo()
       } else {
         this.$message({
           type: 'error',
           message: '保存失败，请重新修改'
         })
       }
     }
   }
}
